module.exports = __webpack_public_path__ + "img/web_back.484f024c.png";